import Image from 'next/image'

import { useRouter } from 'next/router'

import { useState, FC } from 'react'

import { GradationButton } from '@/components/common/General/Button'
import { useTranslation } from '@/i18n/configs'

import { getIsMobile } from '@/utils/getIsMobile'

import { getMobileOS } from '@/utils/getMobileOS'

import { AppDownloadDialog } from '../../Feedback/Dialog/AppDownloadDialog'

export type HeaderProps = {
  isFixed?: boolean
}

export const Header: FC<HeaderProps> = ({ isFixed = false }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const router = useRouter()
  const t = useTranslation()

  const handleClick = () => {
    const isMobile = getIsMobile()
    if (isMobile) {
      const os = getMobileOS()
      switch (os) {
        case 'iOS':
          router.push(
            'https://apps.apple.com/jp/app/bump-%E3%83%90%E3%83%B3%E3%83%97-%E3%82%B7%E3%83%A7%E3%83%BC%E3%83%88%E3%83%89%E3%83%A9%E3%83%9E%E9%85%8D%E4%BF%A1%E3%82%A2%E3%83%97%E3%83%AA/id1630710367'
          )
          break
        case 'Android':
          // TODO: GooglePlayリリース後にURLを変更する
          router.push(
            'https://play.google.com/store/apps/details?id=com.emole.bump'
          )
          break
        default:
          setIsDialogOpen(true)
      }
    } else {
      setIsDialogOpen(true)
    }
  }

  return (
    <header
      className={`w-full sm:flex sm:flex-row-reverse sm:items-center sm:justify-around ${
        isFixed && 'fixed top-8'
      }`}
    >
      <div className="flex justify-between items-center px-16 h-[42px] border-y-[0.5px] border-disabled sm:w-[375px] sm:border-0">
        <div className="flex items-center">
          <Image
            src={'/app-icon.png'}
            width={32}
            height={32}
            alt="アバター画像"
            className="rounded-full"
          />
          <div className="ml-8">
            <p className="text-xs font-medium ">
              {t('header.immersion_experience_text')}
            </p>
            <p className="text-2xs leading-[17px] text-secondary">
              {t('header.app_open_text')}
            </p>
          </div>
        </div>

        <GradationButton
          size="sm"
          className="px-0 w-[53px] h-[28px] leading-[17px]"
          onClick={handleClick}
        >
          開く
        </GradationButton>
      </div>
      <div className="py-16 pl-16 h-[51px] sm:w-[375px]">
        <Image src="/header-logo.png" width="62px" height="31px" alt="ロゴ" />
      </div>

      <AppDownloadDialog
        isOpen={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false)
        }}
      />
    </header>
  )
}
